import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import authReducer from "./reducers/auth";
import registerReducer from "./reducers/register";
import routerReducer from "./reducers/router";
import SetTransformAuth from "./Transforms/SetTransformAuth";
import SetTransformRegister from "./Transforms/SetTransformRegister";
import storage from "redux-persist/es/storage";

const rootPersistConfig = {
  key: "root",
  storage,
  blacklist: [],
  transforms: [SetTransformRegister, SetTransformAuth],
};

const rootReducer = combineReducers({
  auth: authReducer,
  register: registerReducer,
  router: routerReducer,
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

export default persistedReducer;
